export enum DocsVerificationInternalStepEnum {
    CAMERA_ACCESS,
    SCANNING,
    COMPLETED,
    FAILED,
}
